import React, {useState} from 'react'
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types";

type Props = {
    name?       : string
    starred?    : boolean
    collapsible?: boolean
    systemName? : string
    isOpen?     : boolean
    counter?    : number
    controls?   : any   // adiitional controls
    onToggle?   : (a: boolean)=>void
    className?  : string
    children?   : any
}

const debug = false
// const debug = "NavigationMenuSection"

export default function NavigationMenuSection(props: Props) {

    const isOpenStatus = () => {
        let isOpen = true

        if (!_.isNil(props.isOpen)) {
            return props.isOpen
        }

        // init form settings
        if (props.systemName) {
            // // @ts-ignore
            // isOpen = !_.isNil(gd.user.menu[props.systemName]) ? gd.user.menu[props.systemName].isOpen : true

            isOpen = !gd.user.settings.navigation.menuSectionsCollapsed.includes(props.systemName)
        }

        return isOpen
    }

    const [isOpen, setIsOpen] = useState<any>(isOpenStatus())

    // HOVERED

    const [isHovered, setIsHovered] = useState<any>(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    // END HOVERED

    const collapsible = _.get(props, 'collapsible', false)

    const toggle = () => {

        if (!collapsible) return

        const newIsOpen = !isOpen
        setIsOpen(newIsOpen)

        // update server settings
        if (props.systemName) {
            if (newIsOpen) {
                gd.user.settings.navigation.menuSectionsCollapsed.remove(props.systemName)
            } else {
                gd.user.settings.navigation.menuSectionsCollapsed.push(props.systemName)
            }

            gd.user.settings.save()
        }

        // old
        // props.systemName && gd.user.menu.toggleSection(props.systemName, newIsOpen)

        // @ts-ignore
        debug && console.log(debug, 'toggle', props.systemName, gd.user.menu[props.systemName!].isOpen, newIsOpen, gd.user.menu)

        props.onToggle && props.onToggle(newIsOpen)
    }

    const classes = Classes("menu-section", props.className, {
        open: isOpen,
        closed: !isOpen
    })

    return (
        <div className={classes} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {props.name &&
                <div className="menu-header" onClick={toggle}>

                <div className="name" style={{textTransform: "capitalize"}}>
                    {props.name}
                </div>

                {props.starred && <div className="ui5-ico-12 i5-star"/>}

                    <div className="right">

                        {isOpen &&
                            <>
                                {props.controls}
                                {collapsible &&
                                    <ControlButtonStandard size={ControlButtonSize.SIZE_24} type={ControlButtonType.COLLAPSE} />
                                }
                            </>
                        }

                        {!isOpen && collapsible && isHovered &&
                            <ControlButtonStandard size={ControlButtonSize.SIZE_24} type={ControlButtonType.EXPAND} />
                        }

                        {!isOpen && !isHovered &&
                            <div className="counter">{props.counter}</div>
                        }
                    </div>
                </div>
            }

            {isOpen &&
                props.children
            }

        </div>
    )
}

